import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  withStyles,
  Tabs,
  Box,
  Tab,
} from "@material-ui/core";
import { LoadingIndicator } from "../../../../Component";
import styles from "./styles";
import ResultTable from "../ResultTable";
import DunsResultTable from "../DunsResultTable";
import { useTranslation } from "react-i18next";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      style={{ paddingLeft: 15 }}
    >
      {value === index && (
        <Box>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const SearchResult = (props) => {
  const {
    classes,
    localEntities = [],
    localEntitiesLoading,
    mdmEntities = [],
    mdmEntitiesLoading,
    dnbEntities = [],
    dnbEntitiesLoading,
    dnbCount = 0,
    recordActions = [],
    mdmCount,
    localCount,
    localPageNumber,
    mdmPageNumber,
    dnbPageNumber,
    localRowsPerPage,
    mdmRowsPerPage,
    dnbRowsPerPage,
    handleRowsPerPageChange,
    handlePageChange,
  } = props;
  const { t } = useTranslation();

  const [tabValue, setTabValue] = useState(0);

  const tabVal =
    dnbEntities.length > 0
      ? 2
      : localEntities.length > 0
        ? 0
        : mdmEntities.length > 0
          ? 1
          : 0;

  useEffect(() => {
    setTabValue(tabVal);
  }, [tabVal]);

  const getRowActions = (source) => {
    const actions = recordActions.filter((action) => {
      const { sources } = action;
      return !sources || sources.indexOf(source) > -1;
    }).map((action) => {
      const { iconClass, callBack, tooltip } = action;
      return {
        icon: iconClass,
        position: "row",
        tooltip,
        onClick: (event, record) => callBack(record, source),
      };
    });
    return actions;
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const handleTabChange = (e, v) => {
    setTabValue(v);
  };

  const handleLocalPageChange = (e) => {
    handlePageChange(e, "local");
  };

  const handleMdmPageChange = (e) => {
    handlePageChange(e, "mdm");
  };

  const handleDnbPageChange = (e) => {
    handlePageChange(e, "dnb");
  };

  const handleLocalPageSize = (e) => {
    handleRowsPerPageChange(e, "local");
  };

  const handleMdmPageSize = (e) => {
    handleRowsPerPageChange(e, "mdm");
  };

  const handleDnbPageSize = (e) => {
    handleRowsPerPageChange(e, "dnb");
  };

  const renderLocalEntities = () => {
    if (localEntitiesLoading) {
      return renderLoadingIndicator();
    } else if (localEntities && localEntities.length === 0) {
      return null;
    } else {
      return (
        <div className={classes.tableSection}>
          <ResultTable
            data={localEntities}
            recordActions={getRowActions("Local")}
            totalItemsCount={localCount}
            pageNumber={localPageNumber}
            rowsPerPage={localRowsPerPage}
            handlePageChange={handleLocalPageChange}
            handlePageSizeChange={handleLocalPageSize}
            viewInfo={false}
          />
        </div>
      );
    }
  };

  const renderMdmEntities = () => {
    if (mdmEntitiesLoading) {
      return renderLoadingIndicator();
    } else if (mdmEntities && mdmEntities.length === 0) {
      return null;
    } else {
      return (
        <div className={classes.tableSection}>
          <ResultTable
            data={mdmEntities}
            recordActions={getRowActions("MDM")}
            totalItemsCount={mdmCount}
            pageNumber={mdmPageNumber}
            rowsPerPage={mdmRowsPerPage}
            handlePageChange={handleMdmPageChange}
            handlePageSizeChange={handleMdmPageSize}
            viewInfo={true}
          />
        </div>
      );
    }
  };

  const renderDnbEntities = () => {
    if (dnbEntitiesLoading) {
      return renderLoadingIndicator();
    } else if (dnbEntities && dnbEntities.length === 0) {
      return null;
    } else {
      return (
        <div className={classes.tableSection}>
          <DunsResultTable
            data={dnbEntities}
            recordActions={getRowActions("DNB")}
            totalItemsCount={dnbCount}
            pageNumber={dnbPageNumber}
            rowsPerPage={dnbRowsPerPage}
            handlePageChange={handleDnbPageChange}
            handlePageSizeChange={handleDnbPageSize}
          />
        </div>
      );
    }
  };

  const renderTabResults = () => {
    return (
      <div className={classes.container}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={classes.tabStyle}
        >
          <Tab label={t("labels.record.search.localResults", { localCount: localCount })} {...a11yProps(0)} />
          <Tab label={t("labels.record.search.mdmResults", { mdmCount: mdmCount })} {...a11yProps(1)} />
          <Tab label={t("labels.record.search.d&bResults", { dnbCount: dnbCount })} {...a11yProps(2)} />
        </Tabs>

        <TabPanel value={tabValue} index={0} className={classes.root}>
          {renderLocalEntities()}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          {renderMdmEntities()}
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          {renderDnbEntities()}
        </TabPanel>
      </div>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        {renderTabResults()}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(SearchResult);
